// src/pages/Home.js
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import API_ENDPOINTS from '../config/apiConfig';
import axiosAuth from '../api/axiosAuth';

export default function Home() {
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState('');
  const [departments, setDepartments] = useState([]);
  const orgId = '1a1d94b9-cf5e-4f68-947e-824b83177b51'; // Replace with actual org id

useEffect(() => {
  axiosAuth.get(API_ENDPOINTS.PUBLIC_EMPLOYEES(orgId)).then(res => {
    setEmployees(res.data);
    const uniqueDepts = [...new Set(res.data.map(emp => emp.department))];
    setDepartments(uniqueDepts);
  });
}, []);



  const filteredEmployees = employees.filter(emp => {
    const matchName = emp.name.toLowerCase().includes(search.toLowerCase());
    const matchDept = departmentFilter ? emp.department === departmentFilter : true;
    return matchName && matchDept;
  });

  return (
    <div className="bg-gradient-to-tr from-blue-50 to-white min-h-screen py-10">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-extrabold text-blue-800 mb-10 text-center">Our Team</h1>

        {/* Filters */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-10">
          <input
            type="text"
            placeholder="Search by name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full md:w-1/2 px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />
          <select
            value={departmentFilter}
            onChange={(e) => setDepartmentFilter(e.target.value)}
            className="w-full md:w-1/3 px-4 py-3 border border-gray-300 rounded-lg shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          >
            <option value="">All Departments</option>
            {departments.map((dept, idx) => (
              <option key={idx} value={dept}>{dept}</option>
            ))}
          </select>
        </div>

        {/* Employee Cards */}
        <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {filteredEmployees.map(emp => (
            <Link
              to={`/employee/${emp.id}`}
              key={emp.id}
              className="bg-white rounded-2xl p-6 border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 transform text-center"
            >
              <img
                src={emp.profile_pic || 'https://via.placeholder.com/150'}
                alt={emp.name}
                className="w-24 h-24 rounded-full object-cover mx-auto mb-4 border-4 border-blue-100"
              />
              <h3 className="text-lg font-semibold text-gray-800">{emp.name}</h3>
              <p className="text-blue-600 mt-1">{emp.designation}</p>
              <p className="text-sm text-gray-500 mt-1">{emp.department}</p>
            </Link>
          ))}
        </div>

        {filteredEmployees.length === 0 && (
          <div className="text-center text-gray-500 mt-12 text-lg font-medium">
            No employees found.
          </div>
        )}
      </div>
    </div>
  );
}
